import React from 'react';
import { Box, Typography } from '@mui/material';
import Restaurant from '@components/restaurant/models/Restaurant';
import RestaurantStatus from './RestaurantStatus';

interface RestaurantHeaderProps {
    restaurant: Restaurant;
}

const RestaurantHeader: React.FC<RestaurantHeaderProps> = ({ restaurant }) => {
    return (
        <Box
            display={"flex"}
            flexDirection={"column"}
            alignItems={"flex-start"}
            width={"100%"}>
            <Typography fontWeight={600}>
                {restaurant.name}
            </Typography>
            <RestaurantStatus restaurant={restaurant}/>
            {/* <Typography variant='subtitle2'>
                {restaurant.restaurantType.name}
            </Typography> */}
        </Box>
    )
}

export default RestaurantHeader;